export const initialState = {
  profile: null,
  login: null,
  password: null,
  errorMessage: null,
  error: false,
  isloading: false,
  localisationMode: true,
};
